<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/U0FUs8/tc-custom/9781429938716.jpg?1737768517505" alt="This image is the cover for the book Drink the Tea, Willis Gidney Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Drink the Tea, Willis Gidney Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p>Willis Gidney is a born liar and rip-off artist, an expert at the scam. Growing up without parents or a home, by age twelve he is a successful young man, running his own small empire, until he meets Shadrack Davies. That's <i>Captain</i> Shadrack Davies, of the D.C. Police. Davies wants to reform Gidney and becomes his foster father. Though he tries not to, Gidney learns a small amount of ethics from Shad---just enough to bother a kid from the streets for the rest of his life.<br/><br/>Now Gidney is a PI, walking those same streets. So it's no surprise that when his closest friend, jazz saxophonist Steps Jackson, asks Gidney to find his missing daughter, Gidney is compelled to say yes---even though she's been missing for twenty-five years. He finds a woman who may be the girl's mother--and within hours she turns up dead. The police accuse Gidney of the murder and throw him in jail.<br/><br/><br/>Maybe Gidney should quit while he's behind. But when his investigation puts him up against a ruthless multinational corporation, a two-faced congressman, and a young woman desperate to conceal her past, Gidney has no time left for second thoughts. In fact, he may have no time left at all.<br/><br/>Thomas Kaufman is a winner of the PWA Best First Private Eye Novel Competition. His debut novel, <i>Drink the Tea</i>, which boasts an original PI and an engaging cast of characters, adds a fresh perspective to the genre.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Thomas Kaufman
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6a6bc1c2